import { createContext, useContext } from "react";
import { SearchFieldsType } from "../components/SearchForm/SearchForm";

export const SearchFormContext = createContext<SearchFieldsType | null>(null);

export const useSearchFormContext = () =>
    useContext(SearchFormContext) as SearchFieldsType;

export default SearchFormContext;
